<nb-card class="form">
  <nb-card-header
    ><h4>
      {{ "dialogs.fileUpload.title" | translate }}
    </h4></nb-card-header
  >
  <nb-card-body>
    <div *ngIf="uploader.queue.length === 0">
      <div
        ng2FileDrop
        [ngClass]="{ 'filer-hover': hasBaseDropZoneOver }"
        (fileOver)="fileOverBase($event)"
        [uploader]="uploader"
        class="drop-zone"
        alAnchor="knowledge.upload-drop"
      >
        {{ "dialogs.fileUpload.dropText" | translate }}
      </div>
      <p class="or">
        -------- {{ "words.or" | translate | uppercase }} --------
      </p>
      <div class="file-select">
        <!-- accept spiegelt SUPPORTED_MIME_TYPES / SUPPORTED_EXTENSIONS in
             al-filemanager (app/endpoints/files_endpoints.py). Endungen UND
             MIME-Typen, weil die Dateiauswahl je nach System nur eines von
             beidem auswertet. Legacy .ppt/.odp/.doc fehlen bewusst -- dafuer
             gibt es keinen Leser. -->
        <input
          #fileInput
          ng2FileSelect
          [uploader]="uploader"
          type="file"
          accept=".pdf,.txt,.docx,.pptx,.xlsx,.xls,.ods,.csv,.json,.md,.markdown,.html,.htm,application/pdf,text/plain,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.presentationml.presentation,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,application/vnd.oasis.opendocument.spreadsheet,text/csv,application/json,text/markdown,text/html"
          multiple
          class="hidden-input"
        />
        <button nbButton outline status="primary" type="button" (click)="fileInput.click()">
          <nb-icon icon="file-add-outline" pack="eva"></nb-icon>
          {{ "dialogs.fileUpload.selectFiles" | translate }}
        </button>
      </div>

      <p *ngIf="uploader.queue.length == 0">
        {{ "dialogs.fileUpload.supportedFormats" | translate }}
      </p>
    </div>

    <div class="upload-panel" *ngIf="uploader.queue.length > 0">
      <!-- Kopfzeile: eine Summe statt fuenf Tabellenspalten. -->
      <div class="upload-summary">
        <div class="upload-summary__text">
          <span class="upload-summary__count">
            {{
              "dialogs.fileUpload.summary.count"
                | translate : { total: uploader.queue.length }
            }}
          </span>
        </div>
      </div>

      <ul class="upload-list">
        <li class="upload-item" *ngFor="let item of uploader.queue">
          <nb-icon
            class="upload-item__icon"
            icon="file-text-outline"
            pack="eva"
          ></nb-icon>

          <div class="upload-item__main">
            <div class="upload-item__head">
              <span class="upload-item__name" [title]="item?.file?.name">{{
                item?.file?.name
              }}</span>
              <span class="upload-item__size" *ngIf="uploader.options.isHTML5">
                {{ item?.file?.size / 1024 / 1024 | number : "1.2-2" }} MB
              </span>
            </div>
          </div>

          <button
            type="button"
            nbButton
            ghost
            size="small"
            status="basic"
            class="upload-item__remove"
            (click)="item.remove()"
            [attr.aria-label]="'buttons.remove' | translate"
          >
            <nb-icon icon="trash-2-outline" pack="eva"></nb-icon>
          </button>
        </li>
      </ul>

      <p class="upload-keep-open">
        <nb-icon icon="info-outline" pack="eva"></nb-icon>
        {{ "dialogs.fileUpload.backgroundHint" | translate }}
      </p>

      <app-info-badge
        [message]="'dialogs.fileUpload.processionTimeInfo'"
        [type]="'info'"
      ></app-info-badge>
    </div>
  </nb-card-body>
  <nb-card-footer>
    <button
      type="button"
      nbButton
      status="danger"
      outline
      (click)="dialogRef.close()"
    >
      {{ "buttons.cancel" | translate }}
    </button>
    <button
      type="button"
      nbButton
      status="primary"
      (click)="startUpload()"
      alAnchor="knowledge.upload-submit"
      [disabled]="!uploader.queue.length"
    >
      {{ "buttons.upload" | translate }}
    </button>
  </nb-card-footer>
</nb-card>
